import {clamp as mathClamp} from 'lodash';
import { degreesToRadians } from './units';

export type Vector2d = {
    x: number;
    y: number;
};

export const rotateAroundOrigin = (v: Vector2d, origin: Vector2d, degrees: number) => {
    const a = subtract(v, origin);
    const b = rotate(degrees, a);
    return add(origin, b);
};

export const subtract = (a: Vector2d, b: Vector2d) => {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
};

export const rotate = (degrees: number, v: Vector2d) => {
    return rotateRadians(degreesToRadians(degrees), v);
};

export const add = (a: any, b: any) => {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
};

const rotateRadians = (radians: number, v: Vector2d) => {
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);
    return {
        x: v.x * cos - v.y * sin,
        y: v.x * sin + v.y * cos
    };
};

export const clamp = (v: Vector2d, min: Vector2d, max: Vector2d) => {
    return {
        x: mathClamp(v.x, min.x, max.x),
        y: mathClamp(v.y, min.y, max.y)
    };
};